var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33333 3.16666C2.8731 3.16666 2.5 3.53975 2.5 3.99999V13.3333C2.5 13.7936 2.8731 14.1667 3.33333 14.1667H12.6667C13.1269 14.1667 13.5 13.7936 13.5 13.3333V3.99999C13.5 3.53975 13.1269 3.16666 12.6667 3.16666H3.33333ZM1.5 3.99999C1.5 2.98747 2.32081 2.16666 3.33333 2.16666H12.6667C13.6792 2.16666 14.5 2.98747 14.5 3.99999V13.3333C14.5 14.3458 13.6792 15.1667 12.6667 15.1667H3.33333C2.32081 15.1667 1.5 14.3458 1.5 13.3333V3.99999Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6667 0.833344C10.9429 0.833344 11.1667 1.0572 11.1667 1.33334V4.00001C11.1667 4.27615 10.9429 4.50001 10.6667 4.50001C10.3906 4.50001 10.1667 4.27615 10.1667 4.00001V1.33334C10.1667 1.0572 10.3906 0.833344 10.6667 0.833344Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33325 0.833344C5.60939 0.833344 5.83325 1.0572 5.83325 1.33334V4.00001C5.83325 4.27615 5.60939 4.50001 5.33325 4.50001C5.05711 4.50001 4.83325 4.27615 4.83325 4.00001V1.33334C4.83325 1.0572 5.05711 0.833344 5.33325 0.833344Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 6.66666C1.5 6.39051 1.72386 6.16666 2 6.16666H14C14.2761 6.16666 14.5 6.39051 14.5 6.66666C14.5 6.9428 14.2761 7.16666 14 7.16666H2C1.72386 7.16666 1.5 6.9428 1.5 6.66666Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.8def294e357eeffb7a6078710d69a596.svg";
export { ForwardRef as ReactComponent };